export enum SealType {
  AES = 'aes',
  QES = 'qes',
  GOV = 'gov'
}
